
import { useCart } from '../../hooks/useCart';
import Hero from '../../components/feature/Hero';
import Menu from '../../components/feature/Menu';
import Cart from '../../components/feature/Cart';
import Footer from '../../components/feature/Footer';

export default function HomePage() {
  const {
    cartItems,
    isCartOpen,
    setIsCartOpen,
    addToCart,
    removeFromCart,
    updateQuantity,
    clearCart,
    getTotalItems
  } = useCart();

  return (
    <div className="min-h-screen bg-cream">
      {/* Floating Cart Button */}
      <button
        onClick={() => setIsCartOpen(true)}
        className="fixed top-4 right-6 z-40 bg-blue-700 hover:bg-blue-800 text-cream w-14 h-14 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 flex items-center justify-center whitespace-nowrap cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
      >
        <i className="ri-shopping-cart-line text-xl"></i>
        {getTotalItems() > 0 && (
          <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs w-6 h-6 rounded-full flex items-center justify-center font-medium">
            {getTotalItems()}
          </span>
        )}
      </button>

      {/* Main Content */}
      <Hero />
      <Menu onAddToCart={addToCart} />
      <Footer />

      {/* Cart Drawer */}
      <Cart
        isOpen={isCartOpen}
        onClose={() => setIsCartOpen(false)}
        cartItems={cartItems}
        onUpdateQuantity={updateQuantity}
        onRemoveItem={removeFromCart}
        onClearCart={clearCart}
      />
    </div>
  );
}
